import { render, staticRenderFns } from "./MessageIndexView.vue?vue&type=template&id=3f482291&scoped=true"
import script from "./MessageIndexView.vue?vue&type=script&lang=js"
export * from "./MessageIndexView.vue?vue&type=script&lang=js"
import style0 from "./MessageIndexView.vue?vue&type=style&index=0&id=3f482291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f482291",
  null
  
)

export default component.exports